'use client'

import { useState } from 'react'

import { Contact } from '@/api/hooks/useContacts'

import { ContactDialog } from '../contact-dialog'
import DataTable from '../data-table'
import { useContactsTableColumns } from './columns'

type Props = {
  contacts: Contact[]
}

const ContactsTable = ({ contacts }: Props) => {
  // A single dialog instance drives both row-click and the row action, so only one
  // form is ever mounted no matter how many contacts are listed.
  const [editing, setEditing] = useState<Contact | null>(null)
  const columns = useContactsTableColumns({ onEdit: setEditing })

  return (
    <>
      <DataTable
        columns={columns}
        data={contacts}
        getRowProps={contact => ({
          className: 'cursor-pointer',
          onClick: e => {
            // Ignore clicks bubbling from portaled UI (dropdown, delete dialog):
            // their DOM nodes aren't descendants of the row, so contains() is false.
            if (!e.currentTarget.contains(e.target as Node)) return
            setEditing(contact)
          },
        })}
      />
      <ContactDialog
        contact={editing}
        onOpenChange={open => {
          if (!open) setEditing(null)
        }}
        open={Boolean(editing)}
      />
    </>
  )
}

export default ContactsTable
